/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, members: NonNullable<unknown> }} Partner_Org_Seats_ExplainerInputs */



/**
* | output |
* | --- |
* | "Billed for {seats} seats — the highest member count this period. {members} members today." |
*
* @param {Partner_Org_Seats_ExplainerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_seats_explainer = /** @type {((inputs: Partner_Org_Seats_ExplainerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Seats_ExplainerInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abgerechnet werden ${i?.seats} Plätze — der Höchststand an Mitgliedern in diesem Zeitraum. Heute: ${i?.members} Mitglieder.`)
	return /** @type {LocalizedString} */ (`Billed for ${i?.seats} seats — the highest member count this period. ${i?.members} members today.`)
});